export default __webpack_public_path__ + "static/media/aw-logo-w.8efd6702.png";